const getCookies = (): Record<string, string> =>
  document.cookie.split(';').reduce((accumulator, str) => {
    const [key, value] = str.split('=');
    // @ts-expect-error key is possibly 'undefined'.
    return { ...accumulator, [key.trim()]: decodeURIComponent(value) };
  }, {});

export default getCookies;
